import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import {formatDate} from '../../utils/helper.js';
import Paginator from "../../components/Paginator"; 

const ItemDetails = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [tab, setTab] = useState("info");
  const [item, setItem] = useState([]);
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({});
  const [apiData, setApiData] = useState({
        search: "",
        page: 1,
        branch_id: id,
  });
  const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
  };

  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `items/${id}`,
        data: {get_for:'details'}
      });
      const data = response.data;
      if (data.status) {
        const item = data.data;
        setItem(item);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

    useEffect(() => {
      if (tab === "logs") {
        getActivityLogs();
      }
    }, [tab]);

  const getActivityLogs = async () => {
      try {
          setIsLoader(true);
          const response = await ApiService.request({
              method: "GET",
              url: "getActivityLogs", // Replace with your API endpoint
              data: {entityType:"MenuItem", entityId:id, page:apiData.page}
          });
          const data = response.data;
          if (data.status) {
              setLogs(data.data.logs);
              setPagination(data.data.pagination);
          } else {
              toast.error(data.message);
          }
          setIsLoader(false);
      } catch (error) {
          setIsLoader(false);
      }
      
  };



 
  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              Item: {item?.name}
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">
                  Dashboard
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/items" className="text-muted text-hover-primary">
                  Items
                </Link>
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3">
                <button type="button" className="btn btn-sm btn-secondary me-3" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left-short fs-1"></i>  Back
                </button>
          </div>

            
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-5">

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button  className={`nav-link fs-6 px-5 ${tab === "info" ? "active" : ""}`}
                            onClick={() => setTab("info")}
                     type="button"> <i className="bi bi-building-fill fs-5"></i> Item Info</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "logs" ? "active" : ""}`}
                            onClick={() => setTab("logs")}
                      type="button" ><i className="bi bi-clipboard-data-fill fs-5"></i> Audit Logs</button>
                  </li>
              

                 
                </ul>

                {!isLoader && 
                  <div class="tab-content" id="myTabContent">
                    {tab === "info" && (
                      <div class="tab-pane fade show active" >
                        <div className="table-responsive mt-5 w-lg-75">
                          <table className="table align-middle table-striped bitem fs-6">
                            <tbody>
                              <tr>
                                <th className="px-3 fw-semibold">Picture</th>
                                <th>
                                  {item.image && 
                                      <img src={item.image} alt="picture" className="w-70px h-70px object-cover rounded" />
                                  }
                                </th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Item Name</th>
                                <th>{item?.title}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Name Arabic</th>
                                <th>{item?.title_ar}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Price</th>
                                <td> 
                                  {item.discounted_price ?(
                                        <div>
                                            <strike className="text-danger">{currency}  {item.original_price}</strike> <br />
                                            <span>{currency}  {item.discounted_price}</span>
                                        </div>
                                    ):(
                                        <span>{currency}  {item.original_price}</span>
                                    )}
                                </td>
                              </tr>
                               <tr>
                                <th className="px-3 fw-semibold"> Categories</th>
                                <th>
                                  {item.categories && item?.categories.map((category, index) => (
                                    <span className="badge bg-base m-1"  key={index}>{category.title}</span>
                                  ))}
                                </th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Addons</th>
                                <th>
                                  {item.addons && item?.addons.map((addon, index) => (
                                    <span className="badge bg-base m-1"  key={index}>{addon.title}</span>
                                  ))}
                                </th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Description</th>
                                <th>{item?.description}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Description Arabic</th>
                                <th>{item?.description_ar}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> DateTime</th>
                                <td>{formatDate(item?.createdAt,'DD MMM, hh:mm A')} </td>
                              </tr>
                            
                            
                            </tbody>
                          
                          </table>
                        </div>
                      </div>
                    )}
                   
                    {tab === "logs" && (
                      <div class="tab-pane fade show active">
                            <div className="table-responsive">
                                <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th>User</th>
                                            <th>Action</th>
                                            <th>Changes</th>
                                            <th>DateTime</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600 fs-6">
                                        {logs.length > 0 ? logs.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {item.user_id && 
                                                        <div>
                                                            {item.user_id.name} <br />
                                                            {item.user_id.email}
                                                        </div>
                                                    }
                                                </td>
                                                <td> {item.action}</td>

                                                <td> 
                                                   <div className="changes-container">
                                                    {item.changes?.map((change, index) => (
                                                      <div key={index} className="change-item mb-2 p-2 border rounded">
                                                        <div className="font-weight-bold text-capitalize">{change.field}</div>
                                                        <div className="d-flex justify-content-between">
                                                          <div className="old-value pr-2">
                                                            <span className="text-muted small">Old:</span>
                                                            <div className="value-box bg-light p-1">
                                                              {JSON.stringify(change.oldValue)}
                                                            </div>
                                                          </div>
                                                          <div className="new-value pl-2">
                                                            <span className="text-muted small">New:</span>
                                                            <div className="value-box bg-light p-1">
                                                              {JSON.stringify(change.newValue)}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                  
                                                </td>
                                                <td>  {formatDate(item.createdAt,'DD MMM YYYY, hh:mm A')} </td>

                                                {/* <td className="mt-2">
                                                    <Link to={`/orders/${item._id}`} className="btn btn-sm h-35px btn-light-primary">
                                                        <i className="bi bi-eye-fill fs-6"></i>
                                                    </Link>
                                                </td> */}
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> 
                                {isLoader && (
                                    <Loader text="Loading" size="30" className="text-center"  />
                                )}
                                <span>Total Records: {pagination?.total_records}</span>


                                {pagination.total_pages > 1 && (
                                    <Paginator
                                        page={pagination.current_page}
                                        rows={pagination.per_page}
                                        totalRecords={pagination.total_records}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                      </div>
                    )}

                  </div>
                }
                {isLoader && 
                  <Loader color="black" className="mt-5" text="Loading" size="30" />
                }
             
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDetails;
